import {useEffect} from 'react';
import {connect} from 'react-redux';

import {useTileLayer, useTileWMSSource} from './OpenLayers/hooks';

const Colored = 'osm';
const Gray = 'osm-gray';
const Attributions = '&copy; OpenStreetMap contributors';

const OpenStreetMap = ({colored, layer, zIndex = 0}) => {
    const url = `https://ows.terrestris.de/${colored ? Colored : Gray}/service`;
    const source = useTileWMSSource({url, params: {LAYERS: layer}, attributions: Attributions}, [url, layer]);
    const tileLayer = useTileLayer({source, zIndex}, []);

    useEffect(() => tileLayer.setSource(source), [source, tileLayer]);

    return null;
};

const mapStateToProps = ({OSMLayer, OSMColored}) => ({
    layer: OSMLayer,
    colored: OSMColored,
});

export default connect(mapStateToProps)(OpenStreetMap);
